/* "Barrel" of Http Interceptors */
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {EncodeDataInterceptor} from './encode-data.interceptor';
import {HttpErrorHandlingInterceptor} from './http-error-handling.interceptor';
import {LanguageInterceptor} from 'src/app/core/interceptor/language-interceptor.service';
import {BaseUrlInterceptor} from 'src/app/core/interceptor/base-url.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: EncodeDataInterceptor, multi: true},
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorHandlingInterceptor,
    multi: true,
  },
];
